import * as z from "zod/v4";

export const uploadIntelligentInventoryFile = {
  name: "uploadIntelligentInventoryFile" as const,
  input: z.object({}),
  output: z.object({
    headers: z.array(z.string()),
    sampleRows: z.array(z.record(z.string(), z.string())),
    totalRowCount: z.number(),
  }),
};
